import { I } from '@angular/cdk/keycodes';
import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
export interface DialogData {
  AppointmentDate:Date;
}
interface Food {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-date-dialog',
  templateUrl: './date-dialog.component.html',
  styleUrls: ['./date-dialog.component.css']
})

export class DateDialogComponent implements OnInit {
  DateDialogForm: FormGroup;
  public today = new Date();
  public days: number;
  defaultValue = 'WEEKS';
  constructor(private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<DateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
      if(data){
        this.today=new Date(data.AppointmentDate)
      }
    }
  foods: Food[] = [
    { value: 'DAYS', viewValue: 'DAYS' },
    { value: 'WEEKS', viewValue: 'WEEKS' },
    { value: 'MONTHS', viewValue: 'MONTHS' }
  ];


  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.DateDialogForm = this.formBuilder.group({
      daysweek: [''],
      numbers: ['',[Validators.required]],


    });
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  onEnterClick(event: any){
    if(event.keyCode===13){
      this.getdate();
    }
  }
  counts: number;
  addingdays: number;
  getdate() {
    var chkdays = this.DateDialogForm.value.daysweek;
    var result = new Date(this.today);
    if (chkdays == 'DAYS') {
      this.counts = this.DateDialogForm.value.numbers;
      this.addingdays = Number(this.counts);
      result.setDate(result.getDate() + this.addingdays);
    } else if (chkdays == 'WEEKS') {
      this.counts = this.DateDialogForm.value.numbers;
      this.addingdays = Number(Number(this.counts) * 7);
      result.setDate(result.getDate() + this.addingdays);
    } else if (chkdays == 'MONTHS') {
      this.counts = this.DateDialogForm.value.numbers;
      this.addingdays = Number(this.counts);    
      result.setMonth(result.getMonth() + this.addingdays);
    }
   
    
    this.dialogRef.close(result);
  }

}

